import { BaseModel } from 'storm-react-diagrams';
import { DesignChangeMap, IconClass } from '@app/types';
import { getModelIcon } from '../../../functions';
import { BaseChangeItemConflict } from '../types';

export interface GetConflictItemIconProps {
  conflictItem: BaseChangeItemConflict;
  model: BaseModel<any> | null;
}

export function getConflictItemIcon({
  conflictItem,
  model
}: GetConflictItemIconProps): IconClass | null {
  const { key } = conflictItem;
  const designKey = key.split('.')[0] as keyof(DesignChangeMap);
  switch (designKey) {
    case 'appProperties':
    case 'applicationVersion':
    case 'ccxml':
    case 'fillerPrompts':
    case 'folders':
    case 'intentHandling':
    case 'languages':
    case 'unitTests':
      return null;
    case 'application-intents':
    case 'application-modules':
    case 'application-objects':
    case 'application-variables':
    case 'modules':
      if (!model) {
        console.error('No model for provided for conflict item.', conflictItem);
        return null;
      }

      return getModelIcon(model);
    case 'compoundIntents':
      return IconClass.compass;
    case 'csvData':
      return IconClass.grid;
    case 'functions':
      return IconClass.server;
    case 'globalIntents':
      return IconClass.radio;
    case 'graphQLSchemas':
      return IconClass.graphql;
    case 'settings':
      return IconClass.settings;
    default: {
      const neverKey: never = designKey;
      console.error(`No icon configured for key '${neverKey}'.`);
    }
  }

  return null;
}
